.chip {
  position: relative;
  touch-action: none;
  cursor: grab;
}

// Drop indicator before a chip. Absolutely positioned so toggling it never reflows the row.
.chipInsertBefore::before {
  content: "";
  position: absolute;
  left: calc(-1 * var(--hcr-spacing-1));
  top: 0;
  bottom: 0;
  width: 2px;
  border-radius: 1px;
  background-color: var(--hcr-success-color);
}

.chipDragging {
  opacity: 0.4;
  pointer-events: none;
  cursor: grabbing;

  :global(.hcr-tag) {
    border-style: dashed;
  }
}
